module.exports = __webpack_public_path__ + "img/avatar_light.0b9f1455.svg";